import { defineComponent as _defineComponent } from 'vue'
import { Userspaces } from "@busy-human/k9-library";
import { useAuth } from '../store/auth';
import { ref } from 'vue';


type Props = {
    showPopup?: boolean
}
type Emits = {
    (e: 'update:showPoup', value:boolean):void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'new-customer-popup',
  props: {
    showPopup: { type: Boolean }
  },
  emits: ["update:showPoup"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props
const emit = __emit;
const auth = useAuth();

const firstName = ref("")
const lastName = ref("")
const email = ref("")
const phone = ref("")
const error = ref("")


const closePopup = () =>{
    console.log("called!")
    emit('update:showPoup',false)
}

const createAccount = async() =>{
    try{
       let newUser = Userspaces.Defaults()
       newUser.email = email.value
       newUser.phone = phone.value
       newUser.name = {
           firstName:firstName.value,
           lastName: lastName.value,
           fullName: typeof newUser.name == "string" ? newUser.name : newUser.name.fullName,
       }
       const response = await auth.createUserAndResetPass(newUser)
       // console.log("RESP:",response)

       if(response.success){
           alert("Account Created.")
           closePopup()
       }
    }catch(e){
       console.error(e)
       if(typeof e === 'string')
           error.value = e
    }
}


const __returned__ = { props, emit, auth, firstName, lastName, email, phone, error, closePopup, createAccount, get Userspaces() { return Userspaces }, get useAuth() { return useAuth }, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})